/** @type {number | null} */
let finishTimer = null;

/** @type {number | null} */
let safetyTimer = null;

/** @type {number} */
let loadingDepth = 0;

function getLoader() {
  return document.querySelector('[data-cart-loader]');
}

function showLoader() {
  const loader = getLoader();
  const dialog = document.querySelector('.cart-drawer__dialog');

  if (loader instanceof HTMLElement) {
    loader.hidden = false;
    loader.setAttribute('aria-hidden', 'false');
  }

  if (dialog instanceof HTMLElement) {
    dialog.classList.add('cart-drawer--loading');
  }
}

function hideLoader() {
  const loader = getLoader();
  const dialog = document.querySelector('.cart-drawer__dialog');

  if (loader instanceof HTMLElement) {
    loader.hidden = true;
    loader.setAttribute('aria-hidden', 'true');
  }

  if (dialog instanceof HTMLElement) {
    dialog.classList.remove('cart-drawer--loading');
  }

  document.querySelectorAll('cart-items-component').forEach((el) => {
    el.classList.remove('cart-items-disabled');
  });
}

/**
 * Show the cart drawer spinner. Safe to call multiple times during a chain of updates.
 */
export function startCartLoading() {
  loadingDepth += 1;
  showLoader();

  // Never leave the overlay up forever — hard unlock after 3s.
  clearTimeout(safetyTimer);
  safetyTimer = window.setTimeout(() => {
    loadingDepth = 0;
    hideLoader();
    restoreScroll();
  }, 3000);
}

/**
 * Schedule hiding the spinner after pending cart DOM updates settle.
 * @param {number} [delay]
 */
export function scheduleEndCartLoading(delay = 350) {
  clearTimeout(finishTimer);
  finishTimer = window.setTimeout(() => {
    endCartLoading(true);
  }, delay);
}

/**
 * @param {boolean} [force]
 */
export function endCartLoading(force = false) {
  if (!force) {
    loadingDepth = Math.max(0, loadingDepth - 1);
    if (loadingDepth > 0) return;
  }

  clearTimeout(finishTimer);
  clearTimeout(safetyTimer);
  finishTimer = null;
  safetyTimer = null;
  loadingDepth = 0;
  hideLoader();
  restoreScroll();
}

function restoreScroll() {
  if (typeof window.Shopify?.ensureCartDrawerScroll === 'function') {
    window.Shopify.ensureCartDrawerScroll();
    return;
  }

  import('@theme/section-renderer')
    .then(({ ensureCartDrawerScroll }) => ensureCartDrawerScroll())
    .catch(() => {});
}

// Do NOT start loading on every cart:update — that cancelled the end timer and
// left the overlay blocking the drawer when brush-rule exited with no DOM update.
// Explicit startCartLoading() from cart-items / product-form is enough.
document.addEventListener('cart:sections-updated', () => {
  scheduleEndCartLoading(250);
});

document.addEventListener('cart:update', (event) => {
  const source = event instanceof CustomEvent ? event.detail?.data?.source : null;
  // Brush / purchase-type finished a side update — make sure spinner can clear.
  if (source === 'cart-bundle-rule' || source === 'cart-pudding-purchase-type') {
    scheduleEndCartLoading(250);
  }
});

if (typeof window !== 'undefined') {
  window.Shopify = window.Shopify || {};
  window.Shopify.startCartLoading = startCartLoading;
  window.Shopify.scheduleEndCartLoading = scheduleEndCartLoading;
  window.Shopify.endCartLoading = endCartLoading;
}
